import React from 'react';
import Link from 'next/link';

import { BaseButton, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';

import * as ST from './styled';

interface IPayButton {
    payButtonLink?: string,
}

export const PayButton = ({ payButtonLink = '/payments' }: IPayButton) =>
    <Link href={payButtonLink} passHref prefetch={false}>
        <ST.PayBtn>
            <BaseButton type={btnTypes.PRIMARY} text='Оплатить услуги' data-test='payment-btn'/>
        </ST.PayBtn>
    </Link>;


